import React from 'react'
import { motion } from 'framer-motion'
import { transition1 } from '../transitions';

const Edition1 = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section overflow-auto p-40'
    >
    <div className='lg:flex flex-2'>
        <div className='h4 flex-1'>
            Edition 01 <br/>
            25th November 2024 <br/>
                      <p><hr className="border-t border-2 border-gray-800 my-6 w-1/2" /></p>

        </div>
        <div className='flex-1'>
            <p>International Day for the Elimination of Violence Against Women

The 1st Edition of WE is a collaborative piece featuring video submissions from our artists, from all around the world honoring November 25th: International Day for the Elimination of Violence Against Women. This edition will be projected in locations worldwide, focusing on confronting oppression through unity and utilizing our collective strength to challenge systemic violence and dismantle the dominant narratives of fragility.

Fragility is a discourse that imprisons us all, women, and the environment. Don’t be mistaken: the systems that harm and kill us are not our saviors. The notion of “fragile ecosystems” or “fragile genders” is misleading. This project aims to unveil the so-called protective narratives and reveal the hidden violations beneath them.

Isadora Canela
Posters First Edition – Screening
in the Following Cities: <br/><br/>

    <span className='font-bold'>October 31st 2024 </span> – Evia Island, Greece <br/>
    <span className='font-bold'>November 17th 2024 </span> – Genova, Italy <br/>
    <span className='font-bold'>November 24-25th 2024</span> – Norwich, UK <br/>
    <span className='font-bold'>November 25th 2024 </span> – Iceland <br/>
    <span className='font-bold'>November 25th 2024 </span> – Cuneo, Italy <br/>
    <span className='font-bold'>November 25th 2024 </span> – Pisa, Italy <br/>
    <span className='font-bold'>November 25th 2024 </span> – Berlin, Germany <br/>
    <span className='font-bold'>November 26th 2024 </span> – Suffolk, UK 
</p>
        </div>
    </div>
    </motion.section>
  )
}

export default Edition1